import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Information2D } from 'src/app/models/configurators-2d/information2d';
import { DeckingBoardsService } from 'src/app/services/configurators-2d/applications/decking-boards.service';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'ng-casto-decking-boards-class-info',
  templateUrl: './decking-boards-class-info.component.html',
})
export class DeckingBoardsClassInfoComponent implements OnInit {
  classesInformations!: Information2D[];
  currentLang!: string;

  constructor(
    public modalService: ModalService,
    private deckingBoardsService: DeckingBoardsService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentLang = this.translate.getBrowserLang();
    this.deckingBoardsService
      .getClassesInformations()
      .then(result => {
        this.classesInformations = result;
      })
      .catch(function (error) {
        alert(error);
        logError(error);
      });
  }
}
